import React from "react";
import { Table } from "react-bootstrap";
import PropTypes from "prop-types";
import styled from "styled-components";

import { statesConst } from "_constants";
import { phoneCleaner } from "_helpers";

import PhoneMask from "containers/PhoneMask";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 25px 32px 56px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
`;
const SubTitle = styled.h2`
  margin-top: -7px;
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
  color: #7b848d;
`;
const TableHeader = styled.thead`
  height: 42px;
`;
const TableHeaderRow = styled.tr`
  vertical-align: middle;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;
`;
const TableHeaderCell = styled.th`
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #7b848d;
  white-space: nowrap;
  ${({ mwidth }) => (mwidth ? `max-width: ${mwidth}px !important` : "")}
`;
const TableHeaderCellLeft = styled(TableHeaderCell)`
  text-align: left;
`;
const TableBody = styled.tbody`
  border: none !important;
`;
const TableBodyRow = styled(TableHeaderRow)`
  border-top: none;
  height: 40px;
  ${({ index }) => (index % 2 === 0 ? "background-color: #FAFAFF;" : "")}
`;
const TableBodyCell = styled.td`
  text-align: center;
  font-style: normal;
  font-size: 12px;
  white-space: nowrap;
  color: ${({ color }) => color || "#394149"};
`;
const TableBodyCellLeft = styled(TableBodyCell)`
  text-align: left;
`;
const Phone = styled(PhoneMask)`
  border: none;
  /* text-align: center; */
  font-style: normal;
  font-size: 12px;
  white-space: nowrap;
  color: #394149;
  background: none;
`;

function TableRow(props) {
  const { organization, address } = props;

  return (
    <TableBodyRow index={props.index}>
      {!!organization && (
        <>
          <TableBodyCellLeft>{organization?.name || "—"}</TableBodyCellLeft>
          <TableBodyCellLeft>{organization?.type || "—"}</TableBodyCellLeft>
          <TableBodyCellLeft>{organization?.otherType || "—"}</TableBodyCellLeft>
          <TableBodyCellLeft>{organization?.position || "—"}</TableBodyCellLeft>
          <TableBodyCellLeft>{statesConst[organization?.stateOrCountryOfFormation] || "—"}</TableBodyCellLeft>
        </>
      )}
      <TableBodyCellLeft>{props?.firstName || "—"}</TableBodyCellLeft>
      <TableBodyCellLeft>{props?.lastName || "—"}</TableBodyCellLeft>
      <TableBodyCellLeft>{props?.email || "—"}</TableBodyCellLeft>
      <TableBodyCellLeft>{address?.address1 || "—"}</TableBodyCellLeft>
      <TableBodyCellLeft>{props?.countryOfCitizenship || "—"}</TableBodyCellLeft>
      <TableBodyCellLeft>{statesConst[address?.state] || "—"}</TableBodyCellLeft>
      <TableBodyCellLeft>{address?.city || "—"}</TableBodyCellLeft>
      <TableBodyCellLeft>{address?.zip || "—"}</TableBodyCellLeft>
      <TableBodyCellLeft>
        <Phone mask="(999) 999-9999" value={phoneCleaner(props?.phone) || ""} />
      </TableBodyCellLeft>
    </TableBodyRow>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  countryOfCitizenship: PropTypes.string,
  organization: PropTypes.object,
  address: PropTypes.object,
};

function TrademarkOwners({ individual, organization, coOwners }) {
  return (
    <Container>
      <Title>Trademark Owners</Title>
      <SubTitle>Owners information</SubTitle>
      <Table responsive>
        <TableHeader>
          <TableHeaderRow>
            {!!organization && (
              <>
                <TableHeaderCellLeft>ORGANIZATION</TableHeaderCellLeft>
                <TableHeaderCellLeft>TYPE</TableHeaderCellLeft>
                <TableHeaderCellLeft>OTHER TYPE</TableHeaderCellLeft>
                <TableHeaderCellLeft>POSITION</TableHeaderCellLeft>
                <TableHeaderCellLeft>FORMATION COUNTRY/STATE</TableHeaderCellLeft>
              </>
            )}
            <TableHeaderCellLeft>FIRST NAME</TableHeaderCellLeft>
            <TableHeaderCellLeft>LAST NAME</TableHeaderCellLeft>
            <TableHeaderCellLeft>EMAIL</TableHeaderCellLeft>
            <TableHeaderCellLeft>ADDRESS</TableHeaderCellLeft>
            <TableHeaderCellLeft>СITIZENSHIP</TableHeaderCellLeft>
            <TableHeaderCellLeft>STATE</TableHeaderCellLeft>
            <TableHeaderCellLeft>CITY</TableHeaderCellLeft>
            <TableHeaderCellLeft>ZIP</TableHeaderCellLeft>
            <TableHeaderCellLeft>PHONE</TableHeaderCellLeft>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          <TableRow index={0} organization={organization} {...individual} />
          {coOwners.map(({ firstName, lastName }, idx) => (
            <TableRow
              key={idx}
              index={idx + 1}
              organization={organization}
              {...individual}
              firstName={firstName}
              lastName={lastName}
            />
          ))}
        </TableBody>
      </Table>
    </Container>
  );
}

TrademarkOwners.propTypes = {
  individual: PropTypes.object.isRequired,
  organization: PropTypes.object,
  coOwners: PropTypes.arrayOf(PropTypes.object),
};

export default TrademarkOwners;
